import React from 'react';
import PropTypes from 'prop-types';
import { appNamedRoutes } from '../routes';

const NotFound = ({ location }) => (
  <div className="row u-navbar-padding">
    <div className="column">
      <h1>Not Found</h1>
      <p>
        The requested URL <code>{location.pathname}</code> was not found. <br />
        Please, try to <a href={appNamedRoutes.root}>start</a> again.
      </p>
    </div>
  </div>
);


NotFound.propTypes = {
  location: PropTypes.object.isRequired,
}

export default NotFound;
